import { useState } from "react";
import { useInView } from "react-intersection-observer";

const contactInfo = [
	{ icon: "📞", label: "Telepon / WhatsApp", value: "0858-1029-5575" },
	{ icon: "✉️", label: "Email", value: "nusaquindonesia@gmail.com" },
	{ icon: "🌐", label: "Website", value: "www.nusaqu.id" },
	{
		icon: "📍",
		label: "Alamat",
		value:
			"Jl. Kandang Sapi RT.02/RW.08, Sasak Panjang, Kec. Tajur Halang, Kab. Bogor, Jawa Barat 16320",
	},
];

export default function Kontak() {
	const [form, setForm] = useState({
		lembaga: "",
		jenis: "",
		prog: "",
		pic: "",
		pesan: "",
	});
	const { ref, inView } = useInView({ threshold: 0.05, triggerOnce: true });

	const handleChange = (e) =>
		setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

	const kirimWA = () => {
		const { lembaga, jenis, prog, pic, pesan } = form;
		const msg = encodeURIComponent(
			`Assalamualaikum, saya ingin mendaftar program pemberdayaan MASQUDE.\n\n🏢 Lembaga: ${lembaga || "-"}\n🏷️ Jenis: ${jenis || "-"}\n📋 Program: ${prog || "-"}\n👤 PIC: ${pic || "-"}\n📝 Pesan: ${pesan || "-"}\n\nMohon informasi lebih lanjut. Terima kasih.`,
		);
		window.open(`https://wa.me/6285810295575?text=${msg}`, "_blank");
	};

	return (
		<section id="kontak" style={styles.section}>
			<div style={{ textAlign: "center", marginBottom: "0.8rem" }}>
				<span style={styles.lbl}>Hubungi Kami</span>
			</div>
			<h2 style={styles.h2}>Bergabung dengan MASQUDE</h2>
			<p style={styles.sub}>
				Konsultasikan kebutuhan lembaga Anda bersama tim NusaQu Indonesia
			</p>

			<div
				className="grid-2col-kontak"
				ref={ref}
				style={{
					...styles.wrap,
					opacity: inView ? 1 : 0,
					transform: inView ? "translateY(0)" : "translateY(28px)",
					transition: "all 0.65s",
				}}>
				{/* Left */}
				<div>
					<h3 style={styles.leftTitle}>Siap Memberdayakan Lembaga Anda?</h3>
					<p style={styles.leftDesc}>
						Tim NusaQu siap mendampingi lembaga keislaman Anda — Masjid,
						Yayasan, Pesantren, LAZ/ZISWAF, maupun Komunitas Dakwah — bergabung
						dalam program pemberdayaan MASQUDE dari konsultasi hingga
						implementasi.
					</p>
					<div style={styles.ciList}>
						{contactInfo.map((ci) => (
							<div key={ci.label} style={styles.ci}>
								<div style={styles.ciIcon}>{ci.icon}</div>
								<div>
									<div style={styles.ciLabel}>{ci.label}</div>
									<div style={styles.ciVal}>{ci.value}</div>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* Form */}
				<div style={styles.form}>
					<div style={styles.formTitle}>Daftar Program MASQUDE</div>

					{[
						{
							label: "Nama Lembaga",
							name: "lembaga",
							type: "input",
							placeholder: "Contoh: Masjid Al-Ikhlas Bogor",
						},
						{
							label: "Jenis Lembaga",
							name: "jenis",
							type: "select",
							options: [
								"Masjid",
								"Yayasan Keislaman",
								"Pesantren",
								"LAZ / ZISWAF",
								"Komunitas Dakwah",
								"Lainnya",
							],
						},
						{
							label: "Program yang Diminati",
							name: "prog",
							type: "select",
							options: [
								"MASQUDE Qur'an",
								"MASQUDE Halal",
								"MASQUDE Green",
								"MASQUDE Digital",
								"MASQUDE Preneur",
								"Tabungan Qurban",
								"Wakaf Produktif",
								"Semua Program",
							],
						},
						{
							label: "Nama PIC & Nomor HP",
							name: "pic",
							type: "input",
							placeholder: "Nama lengkap & nomor WhatsApp aktif",
						},
					].map((field) => (
						<div key={field.name} style={styles.group}>
							<label style={styles.fieldLabel}>{field.label}</label>
							{field.type === "input" ? (
								<input
									name={field.name}
									value={form[field.name]}
									onChange={handleChange}
									placeholder={field.placeholder}
									style={styles.input}
								/>
							) : (
								<select
									name={field.name}
									value={form[field.name]}
									onChange={handleChange}
									style={styles.input}>
									<option value="">-- Pilih --</option>
									{field.options.map((o) => (
										<option key={o}>{o}</option>
									))}
								</select>
							)}
						</div>
					))}

					<div style={styles.group}>
						<label style={styles.fieldLabel}>Pesan / Pertanyaan</label>
						<textarea
							name="pesan"
							value={form.pesan}
							onChange={handleChange}
							placeholder="Ceritakan kebutuhan lembaga Anda..."
							style={styles.textarea}
							rows={4}
						/>
					</div>

					<button
						onClick={kirimWA}
						style={styles.submitBtn}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "#1a7a32";
							e.currentTarget.style.transform = "translateY(-2px)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "#25D366";
							e.currentTarget.style.transform = "translateY(0)";
						}}>
						Kirim via WhatsApp 📱
					</button>
				</div>
			</div>
		</section>
	);
}

const inputBase = {
	width: "100%",
	padding: "0.7rem 1rem",
	borderRadius: "8px",
	border: "1.5px solid rgba(123,63,0,.2)",
	background: "var(--bg)",
	fontFamily: "Plus Jakarta Sans, sans-serif",
	fontSize: "0.9rem",
	color: "var(--gelap)",
	outline: "none",
	transition: "border-color 0.2s",
};

const styles = {
	section: { padding: "6rem 5%", background: "var(--bg)" },
	lbl: {
		display: "inline-block",
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.28rem 0.95rem",
		borderRadius: "2rem",
		fontSize: "0.72rem",
		fontWeight: 800,
		letterSpacing: "3px",
		textTransform: "uppercase",
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.7rem, 3.5vw, 2.7rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		textAlign: "center",
		marginBottom: "0.8rem",
	},
	sub: {
		color: "var(--abu)",
		fontSize: "0.97rem",
		maxWidth: "600px",
		margin: "0 auto 3rem",
		textAlign: "center",
	},
	wrap: {
		maxWidth: "1080px",
		margin: "0 auto",
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: "4rem",
		alignItems: "start",
	},
	leftTitle: {
		fontFamily: "Lora, serif",
		fontSize: "1.6rem",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "0.8rem",
	},
	leftDesc: {
		color: "var(--abu)",
		fontSize: "0.93rem",
		lineHeight: 1.8,
		marginBottom: "1.5rem",
	},
	ciList: { display: "flex", flexDirection: "column", gap: "1rem" },
	ci: { display: "flex", gap: "0.9rem", alignItems: "flex-start" },
	ciIcon: {
		width: "40px",
		height: "40px",
		minWidth: "40px",
		background: "var(--krem2)",
		borderRadius: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "1.15rem",
	},
	ciLabel: {
		fontSize: "0.75rem",
		color: "var(--abu)",
		fontWeight: 600,
		marginBottom: "0.15rem",
	},
	ciVal: { fontSize: "0.9rem", color: "var(--coklat)", fontWeight: 600 },
	form: {
		background: "white",
		borderRadius: "18px",
		padding: "2rem",
		boxShadow: "0 12px 48px rgba(123,63,0,.1)",
		border: "1.5px solid rgba(123,63,0,.1)",
	},
	formTitle: {
		fontFamily: "Lora, serif",
		fontSize: "1.2rem",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "1.4rem",
	},
	group: { marginBottom: "1rem" },
	fieldLabel: {
		display: "block",
		fontSize: "0.82rem",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "0.4rem",
	},
	input: inputBase,
	textarea: { ...inputBase, resize: "vertical" },
	submitBtn: {
		width: "100%",
		padding: "0.9rem",
		background: "#25D366",
		color: "white",
		border: "none",
		borderRadius: "10px",
		fontFamily: "Plus Jakarta Sans, sans-serif",
		fontSize: "1rem",
		fontWeight: 700,
		cursor: "pointer",
		marginTop: "0.5rem",
		transition: "all 0.25s",
	},
};
